import { filter_day, filter_month, filter_week } from '../../../../../views/marketing/overview/PeriodFilter';

export default {
  filters: {
    [filter_day]: 'Zi',
    [filter_week]: 'Săptămână',
    [filter_month]: 'Lună',
    null: 'Total',
  },
};
